import React, { useEffect, useRef } from "react";

const occasionsData = [
  {
    id: 1,
    title: "Weddings",
    desc: "Preserve wedding moments through embroidered portraits, hoops, and keepsakes that last forever.",
    image: "https://images.unsplash.com/photo-1587271339318-2e78fdf79586?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    icon: "💍"
  },
  {
    id: 2,
    title: "Birthdays",
    desc: "Personalized embroidery gifts that feel thoughtful, unique, and truly special.",
    image: "https://images.unsplash.com/photo-1578922864601-79dcc7cbcea9?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    icon: "🎂"
  },
  {
    id: 3,
    title: "Anniversaries",
    desc: "Celebrate years of love with stitched memories and handcrafted elegance.",
    image: "https://images.unsplash.com/photo-1707831853477-545a84511e57?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    icon: "💖"
  },
  {
    id: 4,
    title: "Baby Gifts",
    desc: "Soft, delicate embroidery perfect for welcoming little ones with warmth and care.",
    image: "https://plus.unsplash.com/premium_photo-1661430931607-70b2e194f741?q=80&w=1174&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    icon: "👶"
  },
  {
    id: 5,
    title: "Home Décor",
    desc: "Handcrafted hoop art and embroidery pieces that bring soul to living spaces.",
    image: "https://images.unsplash.com/photo-1700170928599-d7fc2d4ec97f?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    icon: "🏡"
  },
  {
    id: 6,
    title: "Corporate Gifting",
    desc: "Custom embroidered gifts that leave a lasting impression beyond the usual.",
    image: "https://images.unsplash.com/photo-1670540805686-a73a025c0dd1?q=80&w=1167&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    icon: "🏢"
  }
];

export default function Occasions() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("occ-visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="occ-section" ref={sectionRef}>
      <div className="occ-container">
        
        {/* Header */}
        <div className="occ-header">
          <h2 className="occ-title">Occasions We Create For</h2>
          <div className="occ-divider">
             <span className="occ-thread"></span>
             <span className="occ-needle">✦</span>
             <span className="occ-thread"></span>
          </div>
          <p className="occ-subtitle">
            Thoughtfully handcrafted for life’s most meaningful moments.
          </p>
        </div>

        {/* Grid */}
        <div className="occ-grid">
          {occasionsData.map((item, index) => (
            <div 
              key={item.id} 
              className="occ-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Image Area with "Stitch Ring" */}
              <div className="occ-visual">
                <div className="occ-stitch-ring"></div>
                <div className="occ-img-mask">
                  <img src={item.image} alt={item.title} className="occ-img" />
                </div>
                <div className="occ-icon-badge">{item.icon}</div>
              </div>

              {/* Content Area */}
              <div className="occ-content">
                <h3 className="occ-card-title">{item.title}</h3>
                <p className="occ-card-desc">{item.desc}</p>
                {/* <span className="occ-link">Explore Collection</span> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}